var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarutiHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13560",
    "data-name": "Group 13560",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 234.173,
    height: 24.013,
    viewBox: "0 0 234.173 24.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8258",
    "data-name": "Rectangle 8258",
    width: 234.173,
    height: 24.013,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13559",
    "data-name": "Group 13559",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26908",
    "data-name": "Path 26908",
    d: "M7.888,0A29.331,29.331,0,0,1,.07,4.848l10.106,7.239-.568.269L5.424,9.573C4.062,8.669.682,9.3,0,10.445L7.78,15.89a24.468,24.468,0,0,1,7.855-4.964L5.416,3.806l.539-.424,3.308,2.37c1.65,1.181,2.963,1.493,6.521-.256Z",
    transform: "translate(0 0)",
    fill: "#8b8e91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26909",
    "data-name": "Path 26909",
    d: "M26.431,4.428h4.42l1.3,4.62h.022l1.3-4.62H37.9v7.944H35.046V6.7h-.022l-1.67,5.676H30.972L29.3,6.7H29.28v5.676H26.43Z",
    transform: "translate(-2.703 -0.453)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26910",
    "data-name": "Path 26910",
    d: "M44.971,6.83h-.022l-.935,2.693h1.893Zm-1.938-2.4h3.852l3.385,7.948H46.929l-.333-.912H43.321l-.335.912h-3.34Z",
    transform: "translate(-4.054 -0.453)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26911",
    "data-name": "Path 26911",
    d: "M63.539,4.428h3.142v4.8c0,1.024.59,1.347,1.616,1.347s1.616-.322,1.616-1.347v-4.8h3.142V9.359c0,2.526-1.527,3.295-4.758,3.295s-4.758-.768-4.758-3.295Z",
    transform: "translate(-6.497 -0.453)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26912",
    "data-name": "Path 26912",
    d: "M77.739,6.43H74.832v-2h8.951v2h-2.9v5.943H77.737Z",
    transform: "translate(-7.652 -0.453)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8254",
    "data-name": "Rectangle 8254",
    width: 3.139,
    height: 7.948,
    transform: "translate(76.796 3.973)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26913",
    "data-name": "Path 26913",
    d: "M54.978,6.425H57.16c.523,0,.916.145.916.743,0,.5-.256.743-.867.743H54.981Zm7.182,5.943L59.489,9.882c2.2-.347,1.918-2.507,1.918-3.246A2.175,2.175,0,0,0,60.33,4.709a4.254,4.254,0,0,0-1.885-.289H51.832v7.949h3.142V9.92h.546l2.628,2.448Z",
    transform: "translate(-5.3 -0.451)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26914",
    "data-name": "Path 26914",
    d: "M100.174,8.972C98.637,8.74,98,7.849,98,6.735c0-2.059,2.016-2.616,4.6-2.616,3.541,0,5,.924,5.109,2.6h-3.651a.655.655,0,0,0-.479-.635,2.535,2.535,0,0,0-.979-.166c-.935,0-1.257.233-1.257.567,0,.222.1.368.412.412l3.752.557c1.58.234,2.562.969,2.562,2.316,0,1.936-1.582,2.849-5.11,2.849-2.415,0-5.054-.333-5.067-2.673h3.785a.611.611,0,0,0,.334.568,2.574,2.574,0,0,0,1.069.167c.979,0,1.246-.269,1.246-.645,0-.234-.145-.468-.567-.539Z",
    transform: "translate(-10.01 -0.421)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26915",
    "data-name": "Path 26915",
    d: "M110.192,4.429h3.142v4.8c0,1.023.59,1.347,1.616,1.347s1.616-.323,1.616-1.347v-4.8h3.142V9.36c0,2.526-1.527,3.295-4.753,3.295S110.2,11.887,110.2,9.36Z",
    transform: "translate(-11.268 -0.453)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26916",
    "data-name": "Path 26916",
    d: "M121.727,10.692l4.764-4.262H122.05v-2h8.671V6.163l-4.654,4.209H130.6v2h-8.872Z",
    transform: "translate(-12.447 -0.453)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26917",
    "data-name": "Path 26917",
    d: "M132.687,4.429h3.142v4.8c0,1.023.59,1.347,1.616,1.347s1.616-.323,1.616-1.347v-4.8H142.2V9.36c0,2.526-1.527,3.295-4.753,3.295s-4.758-.768-4.758-3.295Z",
    transform: "translate(-13.568 -0.453)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8255",
    "data-name": "Rectangle 8255",
    width: 3.139,
    height: 7.948,
    transform: "translate(140.95 3.973)",
    fill: "#002783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26918",
    "data-name": "Path 26918",
    d: "M144.8,12.375h3.052l-.06-2.849,3.057,2.849h4.015l-4.362-4.058,4.591-3.89h-3.815L147.857,7.18V4.429H144.8Z",
    transform: "translate(-14.807 -0.453)",
    fill: "#002783",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26919",
    "data-name": "Path 26919",
    d: "M81.268,24.729a2.807,2.807,0,0,1-1.234.812,5.18,5.18,0,0,1-1.769.289,3.5,3.5,0,0,1-1.787-.445,2.97,2.97,0,0,1-1.187-1.291,4.55,4.55,0,0,1-.428-1.99v-.534a4.829,4.829,0,0,1,.4-2.034A2.937,2.937,0,0,1,76.4,18.218a3.766,3.766,0,0,1,3.933.21,2.85,2.85,0,0,1,.933,1.939H79.694a1.56,1.56,0,0,0-.478-.987,1.523,1.523,0,0,0-1.015-.313,1.436,1.436,0,0,0-1.257.62,3.263,3.263,0,0,0-.436,1.843v.5a3.1,3.1,0,0,0,.469,1.866,1.6,1.6,0,0,0,1.374.631,1.8,1.8,0,0,0,1.3-.388V22.788H78.179V21.6h3.089Z",
    transform: "translate(-7.655 -1.816)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26920",
    "data-name": "Path 26920",
    d: "M88.181,22.331H85.076v2.1H88.72v1.3H83.458v-7.85h5.251v1.31H85.076v1.871h3.105Z",
    transform: "translate(-8.534 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26921",
    "data-name": "Path 26921",
    d: "M96.76,25.734H95.142l-3.148-5.166v5.166H90.376v-7.85h1.618l3.154,5.175V17.884H96.76Z",
    transform: "translate(-9.241 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26922",
    "data-name": "Path 26922",
    d: "M104.995,17.884v5.17a2.645,2.645,0,0,1-.806,2.038,3.106,3.106,0,0,1-2.2.75,3.144,3.144,0,0,1-2.183-.727,2.6,2.6,0,0,1-.825-2V17.884h1.618v5.181a1.494,1.494,0,0,0,.369,1.124,1.417,1.417,0,0,0,1.022.354q1.365,0,1.386-1.435V17.884Z",
    transform: "translate(-10.121 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8256",
    "data-name": "Rectangle 8256",
    width: 1.618,
    height: 7.85,
    transform: "translate(96.302 16.055)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26923",
    "data-name": "Path 26923",
    d: "M117.126,25.734h-1.618l-3.148-5.166v5.166h-1.618v-7.85h1.618l3.154,5.175V17.884h1.612Z",
    transform: "translate(-11.324 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26924",
    "data-name": "Path 26924",
    d: "M124.15,22.331h-3.105v2.1h3.645v1.3h-5.263v-7.85h5.251v1.31h-3.633v1.871h3.105Z",
    transform: "translate(-12.212 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26925",
    "data-name": "Path 26925",
    d: "M131.026,22.968v2.766h-1.618v-7.85h3.062a3.545,3.545,0,0,1,1.556.323,2.375,2.375,0,0,1,1.032.919,2.556,2.556,0,0,1,.362,1.356,2.255,2.255,0,0,1-.79,1.821,3.292,3.292,0,0,1-2.186.665Zm0-1.31h1.444a1.42,1.42,0,0,0,.979-.3,1.1,1.1,0,0,0,.337-.863,1.3,1.3,0,0,0-.339-.933,1.271,1.271,0,0,0-.938-.366h-1.483Z",
    transform: "translate(-13.233 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26926",
    "data-name": "Path 26926",
    d: "M140.631,24.116h-2.836l-.54,1.618h-1.72l2.922-7.85h1.5l2.938,7.85h-1.72Zm-2.4-1.31h1.962l-.987-2.938Z",
    transform: "translate(-13.859 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26927",
    "data-name": "Path 26927",
    d: "M147.456,22.86h-1.289v2.874h-1.618v-7.85h2.917a3.3,3.3,0,0,1,2.146.619,2.143,2.143,0,0,1,.755,1.753,2.418,2.418,0,0,1-.348,1.339,2.374,2.374,0,0,1-1.054.855l1.7,3.208v.075h-1.736Zm-1.289-1.31h1.3a1.333,1.333,0,0,0,.944-.311,1.11,1.11,0,0,0,.335-.855,1.185,1.185,0,0,0-.316-.874,1.31,1.31,0,0,0-.968-.318h-1.3Z",
    transform: "translate(-14.781 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26928",
    "data-name": "Path 26928",
    d: "M157.953,19.194h-2.405v6.54h-1.617v-6.54h-2.373v-1.31h6.395Z",
    transform: "translate(-15.498 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26929",
    "data-name": "Path 26929",
    d: "M163.645,23.662a.83.83,0,0,0-.323-.7,4.261,4.261,0,0,0-1.164-.517,8.267,8.267,0,0,1-1.332-.537,2.178,2.178,0,0,1-1.338-1.946,1.9,1.9,0,0,1,.359-1.136,2.348,2.348,0,0,1,1.03-.779,3.878,3.878,0,0,1,1.507-.279,3.525,3.525,0,0,1,1.5.3,2.38,2.38,0,0,1,1.021.86,2.243,2.243,0,0,1,.364,1.261H163.65a1.058,1.058,0,0,0-.339-.838,1.4,1.4,0,0,0-.955-.3,1.5,1.5,0,0,0-.922.251.791.791,0,0,0-.329.661.758.758,0,0,0,.386.642,4.391,4.391,0,0,0,1.135.485,4.891,4.891,0,0,1,2.011,1.03,2.052,2.052,0,0,1,.631,1.531,1.893,1.893,0,0,1-.771,1.6,3.38,3.38,0,0,1-2.076.579,4.013,4.013,0,0,1-1.65-.331,2.611,2.611,0,0,1-1.136-.909,2.327,2.327,0,0,1-.39-1.337h1.622q0,1.3,1.553,1.3a1.514,1.514,0,0,0,.9-.234.761.761,0,0,0,.323-.654",
    transform: "translate(-16.284 -1.816)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26930",
    "data-name": "Path 26930",
    d: "M169.881,23.607a1.8,1.8,0,0,1,.305-1.008,4.264,4.264,0,0,1,1.119-1.03,5.391,5.391,0,0,1-.549-.882,1.955,1.955,0,0,1-.2-.86,2,2,0,0,1,.58-1.49,2.119,2.119,0,0,1,1.561-.574,2.04,2.04,0,0,1,1.443.522,1.707,1.707,0,0,1,.563,1.3,2.058,2.058,0,0,1-.949,1.655l-.6.437,1.354,1.574a3,3,0,0,0,.318-1.38h1.327a4.052,4.052,0,0,1-.706,2.48l1.175,1.365h-1.768l-.406-.464a3.536,3.536,0,0,1-1.994.572,2.737,2.737,0,0,1-1.866-.612,2.031,2.031,0,0,1-.7-1.61m2.643.966a1.98,1.98,0,0,0,1.061-.312l-1.547-1.785-.113.08a1.231,1.231,0,0,0-.479.963,1.017,1.017,0,0,0,.3.76,1.064,1.064,0,0,0,.779.294m-.572-4.767a1.842,1.842,0,0,0,.474,1.02l.416-.276a1.388,1.388,0,0,0,.439-.4.862.862,0,0,0,.121-.464.644.644,0,0,0-.2-.469.767.767,0,0,0-1.049.016.8.8,0,0,0-.2.571",
    transform: "translate(-17.371 -1.816)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26931",
    "data-name": "Path 26931",
    d: "M185.728,24.116h-2.836l-.54,1.618h-1.72l2.922-7.85h1.5l2.938,7.85h-1.72Zm-2.4-1.31h1.962l-.987-2.938Z",
    transform: "translate(-18.471 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26932",
    "data-name": "Path 26932",
    d: "M195.656,23.106a2.779,2.779,0,0,1-.935,2,3.288,3.288,0,0,1-2.225.727,2.953,2.953,0,0,1-2.375-1.016,4.166,4.166,0,0,1-.865-2.79v-.479a4.728,4.728,0,0,1,.4-2,2.993,2.993,0,0,1,1.141-1.323,3.566,3.566,0,0,1,3.911.267,2.982,2.982,0,0,1,.96,2.044h-1.618a1.641,1.641,0,0,0-.423-1.1,1.567,1.567,0,0,0-1.108-.342,1.375,1.375,0,0,0-1.211.58,3.25,3.25,0,0,0-.412,1.8v.593a3.478,3.478,0,0,0,.385,1.86,1.349,1.349,0,0,0,1.216.588,1.6,1.6,0,0,0,1.119-.342,1.55,1.55,0,0,0,.423-1.06Z",
    transform: "translate(-19.352 -1.816)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26933",
    "data-name": "Path 26933",
    d: "M203.7,23.106a2.779,2.779,0,0,1-.935,2,3.288,3.288,0,0,1-2.225.727,2.953,2.953,0,0,1-2.375-1.016,4.166,4.166,0,0,1-.865-2.79v-.479a4.728,4.728,0,0,1,.4-2,2.993,2.993,0,0,1,1.141-1.323,3.566,3.566,0,0,1,3.911.267,2.982,2.982,0,0,1,.96,2.044H202.1a1.641,1.641,0,0,0-.423-1.1,1.567,1.567,0,0,0-1.108-.342,1.375,1.375,0,0,0-1.211.58,3.25,3.25,0,0,0-.412,1.8v.593a3.478,3.478,0,0,0,.385,1.86,1.349,1.349,0,0,0,1.216.588,1.6,1.6,0,0,0,1.119-.342,1.55,1.55,0,0,0,.423-1.06Z",
    transform: "translate(-20.175 -1.816)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26934",
    "data-name": "Path 26934",
    d: "M210.339,22.331h-3.105v2.1h3.645v1.3h-5.263v-7.85h5.252v1.31h-3.634v1.871h3.105Z",
    transform: "translate(-21.025 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26935",
    "data-name": "Path 26935",
    d: "M216.569,23.662a.83.83,0,0,0-.323-.7,4.261,4.261,0,0,0-1.164-.517,8.267,8.267,0,0,1-1.332-.537,2.178,2.178,0,0,1-1.338-1.946,1.9,1.9,0,0,1,.359-1.136,2.348,2.348,0,0,1,1.03-.779,3.878,3.878,0,0,1,1.507-.279,3.525,3.525,0,0,1,1.5.3,2.38,2.38,0,0,1,1.021.86,2.243,2.243,0,0,1,.365,1.261h-1.618a1.058,1.058,0,0,0-.339-.838,1.4,1.4,0,0,0-.955-.3,1.5,1.5,0,0,0-.922.251.791.791,0,0,0-.329.661.758.758,0,0,0,.386.642,4.39,4.39,0,0,0,1.135.485,4.891,4.891,0,0,1,2.011,1.03,2.052,2.052,0,0,1,.631,1.531,1.893,1.893,0,0,1-.771,1.6,3.38,3.38,0,0,1-2.076.579,4.013,4.013,0,0,1-1.65-.331,2.611,2.611,0,0,1-1.136-.909,2.326,2.326,0,0,1-.39-1.337h1.622q0,1.3,1.553,1.3a1.514,1.514,0,0,0,.9-.234.761.761,0,0,0,.323-.654",
    transform: "translate(-21.696 -1.816)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26936",
    "data-name": "Path 26936",
    d: "M224.13,23.662a.83.83,0,0,0-.323-.7,4.261,4.261,0,0,0-1.164-.517,8.267,8.267,0,0,1-1.332-.537,2.178,2.178,0,0,1-1.338-1.946,1.9,1.9,0,0,1,.359-1.136,2.348,2.348,0,0,1,1.03-.779,3.878,3.878,0,0,1,1.507-.279,3.525,3.525,0,0,1,1.5.3,2.38,2.38,0,0,1,1.021.86,2.243,2.243,0,0,1,.364,1.261h-1.618a1.058,1.058,0,0,0-.339-.838,1.4,1.4,0,0,0-.955-.3,1.5,1.5,0,0,0-.922.251.79.79,0,0,0-.329.661.758.758,0,0,0,.386.642,4.39,4.39,0,0,0,1.135.485,4.891,4.891,0,0,1,2.011,1.03,2.052,2.052,0,0,1,.631,1.531,1.893,1.893,0,0,1-.771,1.6,3.38,3.38,0,0,1-2.076.579,4.013,4.013,0,0,1-1.65-.331,2.611,2.611,0,0,1-1.136-.909,2.327,2.327,0,0,1-.39-1.337h1.622q0,1.3,1.553,1.3a1.514,1.514,0,0,0,.9-.234.761.761,0,0,0,.323-.654",
    transform: "translate(-22.469 -1.816)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26937",
    "data-name": "Path 26937",
    d: "M234.08,21.974a4.727,4.727,0,0,1-.41,2.032,3.079,3.079,0,0,1-1.172,1.348,3.467,3.467,0,0,1-3.49.005,3.105,3.105,0,0,1-1.186-1.339,4.6,4.6,0,0,1-.426-2V21.63a4.712,4.712,0,0,1,.417-2.041,3.118,3.118,0,0,1,1.181-1.353,3.464,3.464,0,0,1,3.489,0,3.118,3.118,0,0,1,1.181,1.353,4.7,4.7,0,0,1,.418,2.036Zm-1.639-.356A3.307,3.307,0,0,0,232,19.743a1.562,1.562,0,0,0-2.518-.009,3.265,3.265,0,0,0-.448,1.858v.382a3.346,3.346,0,0,0,.443,1.866,1.549,1.549,0,0,0,2.524.023A3.329,3.329,0,0,0,232.44,22Z",
    transform: "translate(-23.252 -1.816)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26938",
    "data-name": "Path 26938",
    d: "M239.058,22.86h-1.289v2.874h-1.618v-7.85h2.917a3.3,3.3,0,0,1,2.147.619,2.143,2.143,0,0,1,.755,1.753,2.418,2.418,0,0,1-.348,1.339,2.374,2.374,0,0,1-1.054.855l1.7,3.208v.075h-1.736Zm-1.289-1.31h1.3a1.333,1.333,0,0,0,.944-.311,1.11,1.11,0,0,0,.335-.855,1.185,1.185,0,0,0-.316-.874,1.31,1.31,0,0,0-.968-.318h-1.3Z",
    transform: "translate(-24.148 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8257",
    "data-name": "Rectangle 8257",
    width: 1.618,
    height: 7.85,
    transform: "translate(219.153 16.055)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26939",
    "data-name": "Path 26939",
    d: "M252.309,22.331H249.2v2.1h3.646v1.3h-5.263v-7.85h5.252v1.31H249.2v1.871h3.106Z",
    transform: "translate(-25.317 -1.829)",
    fill: "#8b8e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26940",
    "data-name": "Path 26940",
    d: "M258.538,23.662a.83.83,0,0,0-.323-.7,4.26,4.26,0,0,0-1.164-.517,8.269,8.269,0,0,1-1.332-.537,2.178,2.178,0,0,1-1.338-1.946,1.9,1.9,0,0,1,.359-1.136,2.348,2.348,0,0,1,1.03-.779,3.878,3.878,0,0,1,1.507-.279,3.525,3.525,0,0,1,1.5.3,2.38,2.38,0,0,1,1.021.86,2.243,2.243,0,0,1,.364,1.261h-1.618a1.058,1.058,0,0,0-.339-.838,1.4,1.4,0,0,0-.955-.3,1.5,1.5,0,0,0-.922.251.791.791,0,0,0-.329.661.758.758,0,0,0,.386.642,4.39,4.39,0,0,0,1.135.485,4.892,4.892,0,0,1,2.011,1.03,2.052,2.052,0,0,1,.631,1.531,1.893,1.893,0,0,1-.771,1.6,3.379,3.379,0,0,1-2.076.579,4.013,4.013,0,0,1-1.65-.331,2.611,2.611,0,0,1-1.136-.909,2.327,2.327,0,0,1-.39-1.337h1.622q0,1.3,1.553,1.3a1.514,1.514,0,0,0,.9-.234.761.761,0,0,0,.323-.654",
    transform: "translate(-25.987 -1.816)",
    fill: "#8b8e91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarutiHeader);
export default __webpack_public_path__ + "static/media/marutiHeader.f7b237e2cb1eca0e6f2b8d7cb99c93ac.svg";
export { ForwardRef as ReactComponent };